<template>
    <div class="mobileComNav">
        <div class="left" @click="goPage(url)"></div>
        <div class="right">{{title}}</div>
    </div>
</template>

<script>
    export default {
        methods:{
            goPage(url){
                if(url){
                    this.$router.push(url);
                }else{
                    this.$router.go(-1);
                }
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            url: {
                type: String,
                required: false
            }
        }
    }
</script>

<style scoped>
    /* 移动端公共头 */
    .mobileComNav{
        height: 0.8rem;
        width: 100%;
        background: #fff;
        z-index: 10;
        position: fixed;
        top:0;
        left: 0;
    }
    .mobileComNav .left{
        color:#000;
        height: 0.8rem;
        width:0.8rem;
        background: url(../assets/images/home/back.png)no-repeat center;
        background-size:40%;
        position: absolute;
        top:0rem;
        left: 0.15rem;
    }
    .mobileComNav .right{
        width: 100%;
        text-align: center;
        font-size: 0.36rem;
        line-height: 0.8rem;
    }
</style>
